import { z } from "zod";

/**
 * Wire-shape schema for `user.stats.getArtistCommunity`. Single source of
 * truth — the trpc procedure imports this for `.output(...)` and the client
 * durable-cache layer (`apps/mobile/hooks/trpc/useArtistCommunity.ts`)
 * imports it as the parse target.
 */
const artistCommunityFanWireSchema = z.object({
  userId: z.string(),
  name: z.string(),
  image: z.string().nullable(),
  fanScore: z.number(),
  moneySpent: z.number(),
  rank: z.number(),
  movement: z.number(),
  levelName: z.string(),
  shadowColor: z.string(),
  frozen: z.boolean(),
});

export type ArtistCommunityFan = z.infer<typeof artistCommunityFanWireSchema>;

export const artistCommunityWireSchema = z.object({
  topFans: z.array(artistCommunityFanWireSchema),
  me: artistCommunityFanWireSchema.nullable(),
  totalFans: z.number(),
});

export type ArtistCommunity = z.infer<typeof artistCommunityWireSchema>;
